import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ValueChangeDirective } from './value-change.directive';

@NgModule({
  declarations: [ValueChangeDirective],
  imports: [CommonModule],
  exports: [ValueChangeDirective]
})
export class ValueChangeModule {}
